<template>
	<div class="field" :class="{ split: split, right: right, left: left }">
		<I2Label
			v-if="label || helpElementName || $slots.label"
			:label="label ?? ''"
			:helpElementName="helpElementName"
		>
			<slot name="label">{{ label }}</slot>
		</I2Label>
		<slot><div class="warning">Add a control Here</div></slot>
	</div>
</template>

<script setup lang="ts">
import I2Label from "./I2Label.vue"

// Editor dialogs are hosted once at the app level (frame.vue) and triggered via
// the useHelpEditor composable from within I2Label, so I2FormField only needs to
// forward the label + helpElementName.
defineProps({
	label: {
		type: String,
		required: false,
		default: undefined,
	},
	i18nName: {
		type: String,
		default: "",
	},
	helpElementName: {
		type: String,
		default: "",
	},
	required: {
		type: Boolean,
		default: false,
	},
	split: {
		type: Boolean,
		default: false,
	},
	right: {
		type: Boolean,
		default: false,
	},
	left: {
		type: Boolean,
		default: false,
	},
})
</script>

<style scoped>
.field {
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	height: 100%;
	min-height: 80px; /* Ensure minimum height for proper alignment */
}

/* Container for the input field */
.field > :not(:first-child) {
	/* Input field stays at bottom */
	width: 100%;
}

:deep(label) {
	/* Label styling with balanced text wrapping */
	word-wrap: break-word;
	line-height: 1.3;
	text-wrap: balance;
	hyphens: auto;

	/* Label positioning - keep at bottom line */
	margin-bottom: 0.5rem;
	width: 100%;
}

/* Ensure the text-wrap property is supported with vendor prefixes if needed */
@supports (text-wrap: balance) {
	:deep(label) {
		text-wrap: balance;
	}
}
</style>
